import { render } from "./DetailsBar.vue?vue&type=template&id=797a1c71"
import script from "./DetailsBar.vue?vue&type=script&lang=js"
export * from "./DetailsBar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__